import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LookupConfigInterface } from '../../models/dashboard/lookup/lookup-config';

interface IInitialState {
  lookupConfig?: LookupConfigInterface;
}

const initialState: IInitialState = {
  lookupConfig: undefined
};

const lookupConfigDataSlice = createSlice({
  name: 'lookupConfigDataSlice',
  initialState,
  reducers: {
    setLookupConfig(state, action: PayloadAction<LookupConfigInterface>) {
      state.lookupConfig = action.payload;
    },
  },
});

export const lookupConfigDataActions = lookupConfigDataSlice.actions;
export default lookupConfigDataSlice.reducer;
